import React from 'react';
import Loading from '../loading/Loading';

const LoadingFallback = () => {
  return <Loading isLoading />;
};

const styleSheet = document.createElement('style');
styleSheet.innerHTML = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
document.head.appendChild(styleSheet);

export default LoadingFallback;
